"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BlogTags = props => {
  var uniqueTags = [...new Set(props.tags)];
  var className = props.className || '';
  var tagItems = uniqueTags.sort().map(function (tag, key) {
    if (tag) {
      var url = '/topic/' + tag.replace(/\s+/g, '-').toLowerCase();
      return /*#__PURE__*/_react.default.createElement("li", {
        key: key,
        className: "tag_items"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: url
      }, " ", tag, " "));
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container mm-spacing ".concat(className)
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "blog-tag-cloud col-xs-12"
  }, tagItems));
};
var _default = exports.default = BlogTags;